import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={s.footer}>
      <div style={s.inner}>
        <div style={s.col}>
          <div style={s.logo}>HomeIQa</div>
          <p style={s.tagline}>AI-powered home valuation reports</p>
          <p style={s.copy}>All rights reserved.</p>
        </div>
        <div style={s.col}>
          <div style={s.colTitle}>Legal</div>
          <Link to="/terms" style={s.link}>Terms &amp; Conditions</Link>
          <Link to="/privacy" style={s.link}>Privacy Policy</Link>
          <Link to="/refund-policy" style={s.link}>Refund Policy</Link>
        </div>
        <div style={s.col}>
          <div style={s.colTitle}>Resources</div>
          <Link to="/start" style={s.link}>Get Your Report</Link>
          <Link to="/blog" style={s.link}>Blog</Link>
          <span style={{ ...s.link, opacity: 0.5, cursor: 'default' }}>Appraiser Directory <span style={{ fontSize: 9, background: 'rgba(201,168,76,0.2)', padding: '1px 5px', borderRadius: 3, marginLeft: 4, color: '#C9A84C' }}>Coming Soon</span></span>
          <a href="mailto:support@homeiqa.com" style={s.link}>Contact Support</a>
        </div>
      </div>
      <div style={s.disclaimer}>
        HomeIQa reports are for informational purposes only and do not constitute a licensed appraisal as defined by USPAP or applicable state/federal law. Not for use in mortgage lending, refinancing, legal proceedings, or any federally-regulated transaction.
      </div>
    </footer>
  );
}

const s = {
  footer: { background: '#4A1220', padding: '24px 24px 0', fontFamily: "'DM Sans', sans-serif" },
  inner: { maxWidth: 960, margin: '0 auto', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 20, paddingBottom: 16 },
  col: { display: 'flex', flexDirection: 'column', gap: 3 },
  logo: { fontFamily: "'Playfair Display', serif", fontSize: 16, fontWeight: 700, color: '#C9A84C', marginBottom: 2 },
  tagline: { fontSize: 10, color: 'rgba(250,247,242,0.5)', lineHeight: 1.4 },
  copy: { fontSize: 9, color: 'rgba(250,247,242,0.3)', lineHeight: 1.3 },
  colTitle: { fontSize: 9, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#C9A84C', marginBottom: 2 },
  link: { fontSize: 11, color: 'rgba(250,247,242,0.6)', textDecoration: 'none', lineHeight: 1.6 },
  disclaimer: { maxWidth: 960, margin: '0 auto', padding: '12px 0', borderTop: '1px solid rgba(201,168,76,0.1)', fontSize: 9, color: 'rgba(250,247,242,0.25)', lineHeight: 1.5, textAlign: 'center' },
};
